import classNames from 'classnames'
import { IKpi } from 'legacy/lut/classes/models/partner360/ELT/financialData/kpi/IKpi'
import { IPLCParams } from 'legacy/lut/classes/models/partner360/ELT/IPLCParams'
import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import { KpiResultsCell } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/kpiTable/components/kpiResultsCell/KpiResultsCell'
import { mergeColumns } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/kpiTable/helpers/mergeColumns'
import { transformDataForTable } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/kpiTable/helpers/transformDataForTableData'
import { Title } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/title/Title'
import React, { useMemo } from 'react'

import { Nullable } from 'clickNgo/models/utils'
import { Translation } from 'cng-common/features/translations'

import styles from './KpiTable.module.scss'

interface IKpiTable {
  data: IKpi[]
  plcParams: Nullable<IPLCParams>
}
export const KpiTable = ({ data, plcParams }: IKpiTable) => {
  const tableData = transformDataForTable(data)

  const columns = useMemo(
    () =>
      Array.from(
        new Set(
          data.flatMap((category) => category.items.flatMap((item) => Object.keys(item.results)))
        )
      ),
    [data]
  )

  return (
    <div>
      <Title
        text={getFormedEltTranslation('kpi-table-title')}
        variant={'withBackground'}
        translationReplaceParams={[
          { key: '{period}', value: plcParams?.Period || '' },
          { key: '{dateActuals}', value: plcParams?.DateActuals || '' },
          { key: '{dateQuota}', value: plcParams?.DateQuota || '' },
        ]}
      />
      <table className={styles.kpiTable}>
        <thead>
          <tr className={classNames(styles.header)}>
            <th>
              <Translation text={getFormedEltTranslation('kpi-table-category')} />
            </th>
            <th>
              <Translation text={getFormedEltTranslation('kpi-table-name')} />
            </th>
            {columns.map((col) => (
              <th key={col}>
                <Translation text={col} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, idx) => (
            <tr key={idx}>
              <td className={styles.firstColumns}>
                <Translation text={item.category} />
              </td>
              <td className={styles.firstColumns}>
                <Translation htmlAvailable text={item.name} />
              </td>
              {mergeColumns({ rowResults: item.results, columns }).map((cell, i) =>
                cell.colSpan > 0 ? (
                  <td key={i} colSpan={cell.colSpan} style={{ textAlign: 'center' }}>
                    <KpiResultsCell
                      value={cell.items}
                      align={cell.colSpan > 1 ? 'center' : 'start'}
                    />
                  </td>
                ) : null
              )}
            </tr>
          ))}
        </tbody>
      </table>
      <div className={styles.info}>
        <Translation text={getFormedEltTranslation('kpi-table-info')} />
      </div>
    </div>
  )
}
